/** True while a list should keep polling for a score. */
export function aiPending(
  rows: readonly { ai?: { status?: string } | null | undefined }[],
): boolean {
  return rows.some((row) => row.ai?.status === "queued" || row.ai?.status === "running");
}

export function aiPollInterval(
  rows: readonly { ai?: { status?: string } | null | undefined }[],
): number | false {
  return aiPending(rows) ? 4000 : false;
}
